import script from "./CoverageModeSelector.vue?vue&type=script&setup=true&lang=ts"
export * from "./CoverageModeSelector.vue?vue&type=script&setup=true&lang=ts"

import "./CoverageModeSelector.vue?vue&type=style&index=0&id=c6490d6a&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c6490d6a"]])

export default __exports__